import type { RouteRecordRaw } from 'vue-router';

// Усі маршрути розділу «Розклад» оголошені тут одразу (сторінки-заглушки
// заповнюються паралельними задачами), щоб жоден інший файл модуля не
// довелося чіпати при добудові розділів.
//
// Гейти екранів, які раніше питали `lessons:list` / `time-slots:list`, питають
// `:update`. Ці два права — єдині в модулі, які має не тільки диспетчер:
// студент і викладач мають їх заради ВЛАСНОГО розкладу (`myLessons`,
// `teacherSchedule`), і на `:list` кожен із них відкривав редактор розкладу
// прямим URL. Решта маршрутів лишається на `:list` свого ресурсу — тих прав
// поза диспетчером не має ніхто.

export const scheduleRoute: RouteRecordRaw = {
  path: '/schedule',
  name: 'Schedule',
  component: () => import('./pages/EditorPage.vue'),
  meta: {
    layout: 'main',
    authorize: ({ isGranted }) => isGranted('ugi:core:lessons:update', ['*']),
  },
};

export const scheduleCurriculaRoute: RouteRecordRaw = {
  path: '/schedule/curricula',
  name: 'ScheduleCurricula',
  component: () => import('./pages/CurriculaPage.vue'),
  meta: {
    layout: 'main',
    authorize: ({ isGranted }) => isGranted('ugi:core:curricula:list', ['*']),
  },
};

export const scheduleCurriculumDetailRoute: RouteRecordRaw = {
  path: '/schedule/curricula/:id',
  name: 'ScheduleCurriculumDetail',
  component: () => import('./pages/CurriculumDetailPage.vue'),
  meta: {
    layout: 'main',
    authorize: ({ isGranted }) => isGranted('ugi:core:curricula:get', ['*']),
  },
};

export const scheduleTeachingLoadRoute: RouteRecordRaw = {
  path: '/schedule/teaching-load',
  name: 'ScheduleTeachingLoad',
  component: () => import('./pages/TeachingLoadPage.vue'),
  meta: {
    layout: 'main',
    authorize: ({ isGranted }) => isGranted('ugi:core:teaching-load:list', ['*']),
  },
};

export const scheduleDisciplinesRoute: RouteRecordRaw = {
  path: '/schedule/disciplines',
  name: 'ScheduleDisciplines',
  component: () => import('./pages/DisciplinesPage.vue'),
  meta: {
    layout: 'main',
    authorize: ({ isGranted }) => isGranted('ugi:core:disciplines:list', ['*']),
  },
};

export const scheduleCohortsRoute: RouteRecordRaw = {
  path: '/schedule/cohorts',
  name: 'ScheduleCohorts',
  component: () => import('./pages/CohortsPage.vue'),
  meta: {
    layout: 'main',
    authorize: ({ isGranted }) => isGranted('ugi:core:cohorts:list', ['*']),
  },
};

export const scheduleRoomsRoute: RouteRecordRaw = {
  path: '/schedule/rooms',
  name: 'ScheduleRooms',
  component: () => import('./pages/RoomsPage.vue'),
  meta: {
    layout: 'main',
    authorize: ({ isGranted }) => isGranted('ugi:core:rooms:list', ['*']),
  },
};

export const scheduleRoomRankingRoute: RouteRecordRaw = {
  path: '/schedule/room-ranking',
  name: 'ScheduleRoomRanking',
  component: () => import('./pages/RoomRankingPage.vue'),
  meta: {
    layout: 'main',
    authorize: ({ isGranted }) => isGranted('ugi:core:room-ranking-settings:get', ['*']),
  },
};

export const scheduleQualityRoute: RouteRecordRaw = {
  path: '/schedule/quality',
  name: 'ScheduleQuality',
  component: () => import('./pages/ScheduleQualityPage.vue'),
  meta: {
    layout: 'main',
    authorize: ({ isGranted }) => isGranted('ugi:core:lessons:update', ['*']),
  },
};

export const scheduleQualityWeightsRoute: RouteRecordRaw = {
  path: '/schedule/quality/weights',
  name: 'ScheduleQualityWeights',
  component: () => import('./pages/ScheduleQualityWeightsPage.vue'),
  meta: {
    layout: 'main',
    authorize: ({ isGranted }) => isGranted('ugi:core:schedule-quality-settings:get', ['*']),
  },
};

export const scheduleTimeSlotsRoute: RouteRecordRaw = {
  path: '/schedule/time-slots',
  name: 'ScheduleTimeSlots',
  component: () => import('./pages/TimeSlotsPage.vue'),
  meta: {
    layout: 'main',
    authorize: ({ isGranted }) => isGranted('ugi:core:time-slots:update', ['*']),
  },
};

export const scheduleTermsRoute: RouteRecordRaw = {
  path: '/schedule/terms',
  name: 'ScheduleTerms',
  component: () => import('./pages/TermsPage.vue'),
  meta: {
    layout: 'main',
    authorize: ({ isGranted }) => isGranted('ugi:core:terms:list', ['*']),
  },
};

export const scheduleAvailabilityRoute: RouteRecordRaw = {
  path: '/schedule/availability',
  name: 'ScheduleAvailability',
  component: () => import('./pages/AvailabilityPage.vue'),
  meta: {
    layout: 'main',
    authorize: ({ isGranted }) => isGranted('ugi:core:availability-constraints:list', ['*']),
  },
};

export const scheduleRoomAssignmentRoute: RouteRecordRaw = {
  path: '/schedule/room-assignment',
  name: 'ScheduleRoomAssignment',
  component: () => import('./pages/RoomAssignmentPage.vue'),
  meta: {
    layout: 'main',
    authorize: ({ isGranted }) => isGranted('ugi:core:lessons:update', ['*']),
  },
};

export const scheduleScopeRoute: RouteRecordRaw = {
  path: '/schedule/scope',
  name: 'ScheduleScope',
  component: () => import('./pages/SchedulingScopePage.vue'),
  meta: {
    layout: 'main',
    authorize: ({ isGranted }) => isGranted('ugi:core:lessons:update', ['*']),
  },
};

export const scheduleSemestersRoute: RouteRecordRaw = {
  path: '/schedule/semesters',
  name: 'ScheduleSemesters',
  component: () => import('./pages/SemestersPage.vue'),
  meta: {
    layout: 'main',
    authorize: ({ isGranted }) => isGranted('ugi:core:term-mode:update', ['*']),
  },
};

export const scheduleSubstitutionsRoute: RouteRecordRaw = {
  path: '/schedule/substitutions',
  name: 'ScheduleSubstitutions',
  component: () => import('./pages/SubstitutionsPage.vue'),
  meta: {
    layout: 'main',
    authorize: ({ isGranted }) => isGranted('ugi:core:lessons:update', ['*']),
  },
};

export const scheduleActivityKindsRoute: RouteRecordRaw = {
  path: '/schedule/activity-kinds',
  name: 'ScheduleActivityKinds',
  component: () => import('./pages/ActivityKindsPage.vue'),
  meta: {
    layout: 'main',
    authorize: ({ isGranted }) => isGranted('ugi:core:activity-kinds:update', ['*']),
  },
};

export const scheduleAuditRoute: RouteRecordRaw = {
  path: '/schedule/audit',
  name: 'ScheduleAudit',
  component: () => import('./pages/AuditPage.vue'),
  meta: {
    layout: 'main',
    authorize: ({ isGranted }) => isGranted('ugi:core:schedule-events:list', ['*']),
  },
};

// Посилання викладачів на онлайн-пари. Право читання, а не `lessons:update`:
// підсумок і картки бачить кожен, кому видно посилання будь-якої пари, а
// писати картка дає лише з `meeting-links:update` (його перевіряє сервер).
export const scheduleMeetingLinksRoute: RouteRecordRaw = {
  path: '/schedule/links',
  name: 'ScheduleMeetingLinks',
  component: () => import('./pages/MeetingLinksPage.vue'),
  meta: {
    layout: 'main',
    authorize: ({ isGranted }) => isGranted('ugi:core:meeting-links:get', ['*']),
  },
};
